export default "__VITE_ASSET__5eecd352__"